import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
interface Tomo {
  title: string;
  items: string[];
}
const TOMOS: Tomo[] = [{
  title: 'TOMO 1 — Tu clase de pilates de principio a fin',
  items: ['Cómo dejar de improvisar.', 'La estructura ideal de una clase.', 'Cómo administrar correctamente los tiempos.', 'Entradas en calor efectivas.', 'Cómo cerrar una clase memorable.', 'Cómo generar alumnos que quieran volver.']
}, {
  title: 'TOMO 2 — Adaptaciones para necesidades frecuentes',
  items: ['Dolor lumbar.', 'Cervicalgias.', 'Escoliosis.', 'Rodillas.', 'Adultos mayores.', 'Adaptaciones seguras.']
}, {
  title: 'TOMO 3 — Pilates para embarazadas y postparto',
  items: ['Cambios por trimestre.', 'Ejercicios recomendados.', 'Qué evitar.', 'Adaptaciones.', 'Suelo pélvico.', 'Retorno al ejercicio.']
}, {
  title: 'TOMO 4 — 52 clases listas para usar',
  items: ['Clases para principiantes.', 'Intermedios.', 'Avanzados.', 'Core.', 'Movilidad.', 'Clases funcionales.']
}, {
  title: 'TOMO 5 — Pilates con elementos',
  items: ['Pelota.', 'Aro.', 'Banda elástica.', 'Foam roller.', 'Fitball.', 'Secuencias completas.']
}];
export function ContentAccordion() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-beige py-20" data-id="element-28" data-mp="38fmbxxe8vhp">
      <div className="mx-auto max-w-3xl px-6" data-id="element-29" data-mp="39qoxuf3rx78">
        <div className="mx-auto max-w-2xl text-center" data-id="element-30" data-mp="10w7kov86u2qv">
          <p className="inline-flex items-center gap-2 rounded-full border border-brown-light/25 bg-white px-4 py-1.5 text-xs font-bold uppercase tracking-[0.18em] text-brown-light" data-id="element-31" data-mp="10xqwa8iwfpmb">
            <span className="h-1.5 w-1.5 rounded-full bg-brown-light" data-id="element-32" data-mp="r41rji679fa3" />
            Contenido completo
          </p>
          <h2 className="mt-5 font-serif text-4xl font-semibold leading-[1.05] text-brown-dark sm:text-5xl" data-id="element-33" data-mp="m4p2cqruvw4c">
            Todo lo que necesitás para enseñar con criterio
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-brown-dark/70 sm:text-lg" data-id="element-34" data-mp="1eu4fbm32zz2w">
            Cinco tomos prácticos para preparar, adaptar y guiar tus clases con seguridad.
          </p>
        </div>

        <div className="mt-10 space-y-3" data-id="element-35" data-mp="3e4724tf0deqh">
          {TOMOS.map((tomo, i) => {
          const isOpen = open === i;
          return <div key={tomo.title} className="overflow-hidden rounded-2xl border border-brown-light/20 bg-white" data-id="element-36" data-mp="34c1bpo4en5de" data-mpi={i}>
                <button onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left" data-id="element-37" data-mp="2qcjrlm220gad">
                  <span className="font-serif text-base font-semibold text-brown-dark sm:text-lg" data-id="element-38" data-mp="2gevmq3aqhseh">
                    {tomo.title}
                  </span>
                  <ChevronDownIcon className={`h-5 w-5 flex-shrink-0 text-brown-light transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-39" data-mp="2le8hrbbre5s5" />
                </button>
                <AnimatePresence initial={false} data-id="element-40" data-mp="jlamz9yf934k">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-41" data-mp="2444o2j9khhka">
                      <ul className="space-y-2 border-t border-brown-light/15 px-6 py-5" data-id="element-42" data-mp="291ed3xt1nr7l">
                        {tomo.items.map(item => <li key={item} className="flex items-start gap-3 text-sm text-brown-dark/75" data-id="element-43" data-mp="2hvsxufwcfty3">
                            <span className="mt-2 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-brown-light" data-id="element-44" data-mp="2wss2pvzt98ov" />
                            {item}
                          </li>)}
                      </ul>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}